const colors: any = {
  created: "#4b5563",
  initiated: "#eab308",
  approved: "#16a34a",
  rejected: "#dc2626",
  "in-approval": "#eab308",
  "in-progress": "#eab308",
};

export { colors };
